export default "__VITE_ASSET__CfWUVjrn__"